package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/**
 * 内置 object {@code timer} 的方法占位描述符集合。
 *
 * <p>仅做编译期"已知方法名 + 参数数量"校验，不参与 lower / 重写；与 LocalApiMethods 同款写法。
 * trailing lambda 在 ExpressionParser 已被并入 args 列表，所以 {@code timer.timeout(1000) { ... }}
 * 在描述符层面是 2 个参数的调用形态。</p>
 */

/** timer.timeout(delayMs, lambda)。 */
object TimerTimeoutMethod : MethodDescriptor {
    override val name: String = "timeout"
    override val arity: Arity = Arity.Fixed(2)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** timer.interval(periodMs, lambda) 或 timer.interval(initialDelay, period, lambda)。 */
object TimerIntervalMethod : MethodDescriptor {
    override val name: String = "interval"
    override val arity: Arity = Arity.Range(2, 3)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** timer.delayAsync(ms)。 */
object TimerDelayAsyncMethod : MethodDescriptor {
    override val name: String = "delayAsync"
    override val arity: Arity = Arity.Fixed(1)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** timer.compute(lambda)。 */
object TimerComputeMethod : MethodDescriptor {
    override val name: String = "compute"
    override val arity: Arity = Arity.Fixed(1)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** timer.cancelAll()。 */
object TimerCancelAllMethod : MethodDescriptor {
    override val name: String = "cancelAll"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

val TimerApiMethodMap: Map<String, MethodDescriptor> = listOf(
    TimerTimeoutMethod,
    TimerIntervalMethod,
    TimerDelayAsyncMethod,
    TimerComputeMethod,
    TimerCancelAllMethod,
).associateBy { it.name }
